import { defer } from 'react-router-dom'
import { getQueryStringParamsFromStringUrl, logger } from '$utils'
import { isAppStateReady } from 'src/state/store'
import { UnavailabilityStatus } from '$constants'
import { unavailabilityService } from '$services'
import { CoreApiError, IUnavailabilityRecord } from '$models'

/** What the unavailability status page renders: the updated record, or errorMessage when refused. */
export interface UnavailabilityStatusPageData {
  updatedUnavailability?: IUnavailabilityRecord
  /** Both come from the email link. */
  firstName?: string
  lastName?: string
  errorMessage?: string
}

export default async function loader({ request: { url } }) {
  const queryParams = getQueryStringParamsFromStringUrl(url)

  logger.debug(
    '[loader] About to await AppState being ready in employee Unavailability Status loader'
  )
  await isAppStateReady()
  logger.debug(
    '[loader] AppState should now be ready in employee Unavailability Status loader'
  )

  // Grab url params
  const {
    firstname: firstName,
    lastname: lastName,
    recordId,
    status,
  } = queryParams

  // NOTE that it is expected requests to this loader will happen on a page
  // with a one time token. This means you can't make API calls to our normal
  // backend as the user will most likely _not_ be authenticated. Data that
  // needs to be displayed can be included as url query params where appropriate.

  // Immediately process the status update, the response this to single API call
  // is used for the display on the page about to be loaded.
  const data: Promise<UnavailabilityStatusPageData> = unavailabilityService
    .updateStatus(recordId, status as unknown as UnavailabilityStatus)
    .then((updatedUnavailability) => ({
      updatedUnavailability,
      firstName,
      lastName,
    }))
    .catch((error) => {
      logger.error('Employee Unavailability Status update error', error)
      // A 403 says why the update was refused, so the page shows that instead of the
      // generic error.
      const errorMessage =
        error instanceof CoreApiError && error.code === 403
          ? error.description
          : undefined
      return { errorMessage }
    })

  return defer({ data })
}
